var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.724C0 5.57317 4.98625 0.586914 11.1371 0.586914C17.288 0.586914 22.2742 5.57317 22.2742 11.724C22.2742 17.8749 17.288 22.8611 11.1371 22.8611C4.98625 22.8611 0 17.8749 0 11.724Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7785 7.89554C16.2897 8.0358 16.6922 8.44909 16.8288 8.97393C17.0771 9.92514 17.0771 11.9099 17.0771 11.9099C17.0771 11.9099 17.0771 13.8945 16.8288 14.8458C16.6922 15.3706 16.2897 15.7839 15.7785 15.9242C14.8522 16.1791 11.1373 16.1791 11.1373 16.1791C11.1373 16.1791 7.42243 16.1791 6.49603 15.9242C5.98487 15.7839 5.58231 15.3706 5.4457 14.8458C5.19751 13.8945 5.19751 11.9099 5.19751 11.9099C5.19751 11.9099 5.19751 9.92514 5.4457 8.97393C5.58231 8.44909 5.98487 8.0358 6.49603 7.89554C7.42243 7.64062 11.1373 7.64062 11.1373 7.64062C11.1373 7.64062 14.8522 7.64062 15.7785 7.89554ZM10.0236 10.2392V13.9516L12.9935 12.0955L10.0236 10.2392Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/YoutubeIcon.a99d07c32fd599e9dedbb32ee3c3ef40.svg";
export { ForwardRef as ReactComponent };